import { useExternalAssessmentQuery } from '@common/cache';
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export const useAssessmentPage = () => {
  const [isConfirmed, setIsConfirmed] = useState<boolean>(false);

  const { assessment_id = '' } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('t');
  const assessmentQuery = useExternalAssessmentQuery({
    assessment_id,
    token: token ?? '',
  });

  const handleConfirm = () => {
    setIsConfirmed(true);
  };

  const handleTryAgain = () => {
    assessmentQuery.refetch();
  };

  return {
    assessment: assessmentQuery.data,
    assessment_id,
    token,
    loading: assessmentQuery.isLoading,
    isConfirmed,
    handleConfirm,
    handleTryAgain,
  };
};
